import { render, staticRenderFns } from "./LinkAgeSetting.vue?vue&type=template&id=3b1f741b&scoped=true&"
import script from "./LinkAgeSetting.vue?vue&type=script&lang=js&"
export * from "./LinkAgeSetting.vue?vue&type=script&lang=js&"
import style0 from "./LinkAgeSetting.vue?vue&type=style&index=0&id=3b1f741b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1f741b",
  null
  
)

export default component.exports